import React from "react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
    const handleNavigate = () => {
      navigate(-1);
    };
  return (
    <div className="">
      <div className="WrapperBox">
        <div className="Small-Wrapper" style={{ padding: 40 }}>
          <div className="TitleBox">
            <h4 className="Title">Privacy Policy</h4>
            <button type="submit" className="Button" onClick={handleNavigate}>
              <i className="fa fa-long-arrow-left" aria-hidden="true" /> Back
            </button>
          </div>
          <div>
            <p>
              Learn2Prospuh is committed to protecting the privacy of its users.
              This Privacy Policy outlines how we collect, use, and safeguard
              your information:
            </p>
            <ul>
              <li>
                <strong>1. Information Collected:</strong> We may collect
                personal data such as name, age, grade level, and contact
                details when students sign up. Additional data such as course
                progress, challenge participation, and engagement analytics may
                be gathered to improve user experience.
              </li>
              <br />
              <li>
                <strong>2.How We Use Your Data:</strong> The information
                collected is used for educational tracking, platform
                improvement, and user engagement. We do not sell or share
                personal data with third parties.
              </li>
              <br />
              <li>
                <strong>3. Security Measures:</strong> We implement strict
                security protocols to protect user data from unauthorized access
                or breaches.
              </li>
              <br />
              <li>
                <strong>4. Cookies &amp; Tracking:</strong> Learn2Prospuh may
                use cookies and tracking technologies to enhance user experience
                and provide personalized learning recommendations
              </li>
              <br />
              <li>
                <strong>5. Parental &amp; Teacher Involvement:</strong> For
                younger students, we encourage parental or teacher guidance when
                using the platform.
              </li>
              <br />
              <li>
                <strong>6. Data Retention:</strong> User data is stored securely
                for as long as necessary to support learning activities. Users
                can request account deletion at any time.
              </li>
              <br />
              <li>
                <strong>7. Third-Party Links:</strong> The platform may include
                links to external educational resources. Learn2Prospuh is not
                responsible for the privacy practices of third-party websites.
              </li>
              <br />
              <li>
                <strong>8. Changes to Policy:</strong> Learn2Prospuh reserves
                the right to update this Privacy Policy. Users will be notified
                of any significant changes.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
